import { MasterFixture } from "@CommonApi/inputs/master-fixtures/all";
import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflowStorePogFixture_storePogId_ =
  "/merchflow/store-pogs/:storePogId/fixtures";

export type ParamsGetMerchflowStorePogFixture_storePogId_ = ExtractRouteParams<
  typeof RouteGetMerchflowStorePogFixture_storePogId_
>;

export type ResponseGetMerchflowStorePogFixture_storePogId_ = MasterFixture[];
